
import React, { useRef, useEffect, useState, ChangeEvent } from 'react';

import Layout from '../../../components/Layout/MembersPortalLayout/MembersPortalLayout';

import changePasswordService from './changePasswordService';

import MessageModal from '../../../components/Modal/MessageModal';

import warningIcon from '../../../assets/warning-icon.png';
import successIcon from '../../../assets/success-icon.png';

import { ChangePasswordError, ChangePasswordInput } from '../../../interface/MembersPortal/IChangePassword';

import { ResponseChangePassword } from '../../../interface/MembersPortal/IChangePassword';
import ConfirmModal from '../../../components/Modal/ConfirmModal';

function ChangePasswordPage() {

    const [messageModalOpen, setMessageModalOpen] = useState(false);
    const [messageModalIcon, setMessageModalIcon] = useState(successIcon);
    const [messageModalText, setMessageModalText] = useState('');
    const [changePasswordError, setChangePasswordError] = useState<ChangePasswordError>();
    const [changePasswordInput, setChangePasswordInput] = useState<ChangePasswordInput>();
    const [confirmPassword, setConfirmPassword] = useState<string>();



    function onCloseMessageModal() {
        setMessageModalOpen(false);
    }


    async function changePassword() {

        try {

            var response = await changePasswordService.changePassword(changePasswordInput!);

            var responseChangePassword: ResponseChangePassword = response.data;

            if (responseChangePassword.isSuccess) {

                setMessageModalIcon(successIcon);
                setMessageModalText('Password has been changed successfully');

                setChangePasswordInput({
                    oldPassword: '',
                    newPassword: '',
                });
                setConfirmPassword('');
            }
            else {

                setMessageModalIcon(warningIcon);
                setMessageModalText('Password didn\'t match');
            }


            setMessageModalOpen(true);

        }
        catch (err) {
            throw err;
        }

    }

    function isAllowedChangePassword(): boolean {

        var isAllowed = true;

        setChangePasswordError({});

        if (!changePasswordInput?.oldPassword) {
            isAllowed = false;
            setChangePasswordError((prevState) => ({
                ...prevState,
                oldPassword: 'Old password is required.'
            }));
        }



        if (!changePasswordInput?.newPassword) {
            isAllowed = false;
            setChangePasswordError((prevState) => ({
                ...prevState,
                newPassword: 'New password is required.'
            }));
        }
        else if (changePasswordInput?.newPassword == changePasswordInput?.oldPassword) {
            isAllowed = false;
            setChangePasswordError((prevState) => ({
                ...prevState,
                newPassword: 'New password must not be equal to Old password.'
            }));
        }


        if (!confirmPassword || confirmPassword != changePasswordInput?.newPassword) {
            isAllowed = false;
            setChangePasswordError((prevState) => ({
                ...prevState,
                confirmPassword: 'Confirm password must be equal to new password.'
            }));

        }

        return isAllowed;
    }


    async function changePasswordButtonClick() {

        try {

            document.querySelector('.loader-container')?.classList.add('loader');

            var isAllowed = isAllowedChangePassword();

            if (isAllowed) {

                await changePassword();
            }

        }
        catch (err) {
            console.log(' changePasswordButtonClick err:: ', err);

        }
        finally {

            document.querySelector('.loader-container')?.classList.remove('loader');
        }

    }

    useEffect(() => {

        (async () => {

            // document.querySelector('.loader-container')?.classList.add('loader');


            // document.querySelector('.loader-container')?.classList.remove('loader');
        })();

    }, []);

    return (
        <Layout>

            <MessageModal
                isOpen={messageModalOpen}
                icon={messageModalIcon}
                message={messageModalText}
                onClose={onCloseMessageModal}
            />
            <div className="title-container">
                <div className="dv-title">
                    <div>
                        <h1>Change Password</h1>

                    </div>
                </div>
            </div>
            <div className='content-container'>
                <div className='padding-container'>

                    <div className="label-1">Old Password:</div>
                    <div>
                        <input
                            type="password"
                            className={changePasswordError?.oldPassword ? "textbox-red-2" : "textbox-green-2"}
                            name="oldPassword"
                            id="oldPassword"
                            placeholder="Old Password"
                            value={changePasswordInput?.oldPassword}
                            onChange={(event) => {
                                setChangePasswordInput((prevState) => ({
                                    ...prevState,
                                    oldPassword: event.target.value
                                }));
                            }}
                        />
                    </div>
                    <div>
                        <label className='label-error-1'>{changePasswordError?.oldPassword}</label>
                    </div>

                    <div className="label-1">New Password:</div>
                    <div>
                        <input
                            type="password"
                            className={changePasswordError?.newPassword ? "textbox-red-2" : "textbox-green-2"}
                            name="newPassword"
                            id="newPassword"
                            placeholder="New Password"
                            value={changePasswordInput?.newPassword}
                            onChange={(event) => {
                                setChangePasswordInput((prevState) => ({
                                    ...prevState,
                                    newPassword: event.target.value
                                }));
                            }}
                        />
                    </div>
                    <div>
                        <label className='label-error-1'>{changePasswordError?.newPassword}</label>
                    </div>

                    <div className="label-1">Confirm Password:</div>
                    <div>
                        <input
                            type="password"
                            className={changePasswordError?.confirmPassword ? "textbox-red-2" : "textbox-green-2"}
                            name="confirmPassword"
                            id="confirmPassword"
                            placeholder="Confirm Password"
                            value={confirmPassword}
                            onChange={(event) => {
                                setConfirmPassword(event.target.value);
                            }}
                        />
                    </div>
                    <div>
                        <label className='label-error-1'>{changePasswordError?.confirmPassword}</label>
                    </div>
                    <div style={{ width: '50%' }}>
                        <button type="button" id="btnNext"
                            className="btn-green-100 center-middle width-100 "
                            onClick={changePasswordButtonClick}
                        >Change Password</button>
                    </div>


                </div>


            </div>
        </Layout>
    );

}


export default ChangePasswordPage;